/* global Highcharts, _ */

(function () {
  'use strict';

  var id = "person";
  var DYNAMIC_PERSON_ID = -1;
  angular.module('wsLrs.controllers').factory(id + ".Utils", ['Api', 'CardQueryResource', '$q', '$routeParams', 'wsColors', function (Api, CardQueryResource, $q, $routeParams, wsColors) {
    return {
      fetchPersonData: function fetchPersonData(cardId, $scope) {
        var dataUrl;
        if ($scope && $scope.program) {
          cardId = $scope.program.id;
          dataUrl = "/program/person/" + $scope.person.id;
        } else {
          dataUrl = "/personcard";
          if ($scope.personId) {
            dataUrl += "/person/" + (typeof $scope.personId === "string" ? "customId/" : "") + $scope.personId;
          }
        }
        return CardQueryResource.getWithProgress(dataUrl, cardId, null, $scope.cardToPreview, "personProgress");
      },
      // This will fetch the whole set of Program data.  getListerData is a function that will extract
      // a particular array for use by one of the listers
      fetchData: function fetchData(params, $scope, getListerData) {
        if ($scope.fetchInProgress) {
          return $scope.dataFetched;
        } else if ($scope.cachedListerItems) {
          var sortedList = this.searchAndSort($scope.cachedListerItems, params);
          var deferred = $q.defer();
          deferred.resolve(sortedList);
          return deferred.promise;
        } else {
          $scope.fetchInProgress = true;
          var self = this;
          return this.fetchPersonData($routeParams.cardId, $scope).then(function success(response) {
            $scope.cachedListerItems = getListerData(response.results[0].result);
            $scope.fetchInProgress = false;
            $scope.hasData = $scope.cachedListerItems.length > 0;

            // We are sorting here because the default lister behavior of sorting at the
            // resource won't work for us since all of our data comes form a single resource
            // This will default to a 'name' sort
            return self.searchAndSort($scope.cachedListerItems, params);
          });
        }
      },
      // Used in conjunction with the lister and search functionality
      searchAndSort: function searchAndSort(results, params) {
        /*jshint camelcase: false */
        // Filter if we have a name search
        if (params.in_name) {
          results = _.filter(results, function (x) {
            var name = x.name.toLowerCase();
            var searchString = params.in_name.toLowerCase();
            return name.indexOf(searchString) > -1;
          });
        }
        var limit = params._limit || params.limit || 10,
          offset = params._offset || 0,
          orderBy = params.order_by || "name";
        var reverse = false;
        if (orderBy.lastIndexOf("-", 0) === 0) {
          orderBy = orderBy.substring(1, orderBy.length);
          reverse = true;
        }
        var orderingMethod = null;
        if (orderBy === "name") {
          orderingMethod = function orderingMethod(item) {
            return item.name.toLowerCase();
          };
        } else {
          orderingMethod = function orderingMethod(item) {
            return item[orderBy];
          };
        }
        results = _.sortBy(results, orderingMethod);
        if (reverse) {
          results.reverse();
        }

        // numResults is the TOTAL (after the search filter), before slicing out a page
        var numResults = _.size(results);
        results = results.slice(offset, limit + offset);
        return {
          "results": results,
          "count": numResults
        };
      },
      /*jshint camelcase: false */
      fetchSearchSuggestions: function fetchSearchSuggestions(params, $scope) {
        var deferred = $q.defer();
        var matches = _.filter($scope.cachedListerItems, function (x) {
          var name = x.name.toLowerCase();
          var searchString = params.in_name.toLowerCase();
          return name.indexOf(searchString) > -1;
        });
        deferred.resolve({
          "results": matches
        });
        return deferred.promise;
      },
      setupInteractionChart: function setupInteractionChart(dailyActivity, $scope) {
        var maxDailyActivity = _.reduce(dailyActivity, function (memo, arr) {
          if (arr[1] > memo) {
            return arr[1];
          } else {
            return memo;
          }
        }, 0);
        $scope.totalInteractions = _.reduce(dailyActivity, function (memo, arr) {
          return memo + arr[1];
        }, 0);
        var lastDayWithData;
        _.each(dailyActivity, function (pair) {
          // pair is <date>|<count of activities>, date is originally in millis so is parsed here
          if (pair[1] > 0) {
            lastDayWithData = pair[0];
          }
        });

        // Only show chart data up to the last date that actually has data
        var dailyActivitySeries = _.filter(dailyActivity, function (pair) {
          return pair[0] <= lastDayWithData;
        });
        $scope.activityChart = {
          credits: {
            enabled: false
          },
          chart: {
            type: 'areaspline',
            margin: [10, 0, 0, 0],
            height: 80
          },
          title: {
            text: null
          },
          xAxis: {
            labels: {
              enabled: false
            },
            lineWidth: 0,
            gridLineWidth: 0
          },
          yAxis: {
            title: {
              text: null
            },
            labels: {
              enabled: false
            },
            lineWidth: 0,
            gridLineWidth: 0,
            max: maxDailyActivity,
            // Series max
            min: 0
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              lineWidth: 1,
              fillOpacity: 0.5,
              marker: {
                enabled: true,
                symbol: 'circle',
                radius: 2,
                fillColor: wsColors.wsGray
              }
            }
          },
          series: [{
            name: 'Activity',
            data: _.map(dailyActivitySeries, function (point) {
              return [Date.parse(point[0]), point[1]];
            }),
            color: wsColors.wsBlue
          }],
          tooltip: {
            formatter: function formatter() {
              return this.y + (this.y === 1 ? ' interaction ' : ' interactions ') + 'on ' + Highcharts.dateFormat('%b  %e, %Y', new Date(this.x)) + '.';
            }
          }
        };
      }
    };
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/person/:cardId', {
      templateUrl: 'modules/app/person/person-detail.html',
      controller: id + '.Detail',
      resolve: {
        currentUserPerson: ['PersonUtils', function (PersonUtils) {
          return PersonUtils.getPerson();
        }],
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/person/:cardId/top', {
      templateUrl: 'modules/app/person/person-card.html',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/person/:personId', {
      templateUrl: 'modules/app/person/person-detail.html',
      controller: id + '.Detail',
      resolve: {
        currentUserPerson: ['PersonUtils', function (PersonUtils) {
          return PersonUtils.getPerson();
        }],
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "person": "person"
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + ".Utils", "$routeParams", "User", function ($scope, CardRegistry, Utils, $routeParams, User) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    if ((!$scope.config.filter.personIds || $scope.config.filter.personIds.length === 0) && (!$scope.config.filter.personCustomIds || $scope.config.filter.personCustomIds.length === 0)) {
      $scope.hasData = false;
      $scope.card.title = 'New Person';
      $scope.defaultSummary = "Details about a single person's activity";
      $scope.noDataMsg = "Please select a person";
      return;
    }
    Utils.fetchPersonData($scope.cardId, $scope).then(function success(response) {
      var person;
      if (response.results[0].result.person.id === DYNAMIC_PERSON_ID) {
        person = User.get().user;
      } else {
        person = response.results[0].result.person;
      }
      $scope.data = response.results[0].result;
      $scope.person = person;
      $scope.hasData = true;
      $scope.card.title = person.name;
      $scope.defaultSummary = Number($scope.data.totalStatements).toLocaleString() + " interactions by " + person.name + " since " + moment.utc($scope.data.firstStatementDate).format('ll');
      Utils.setupInteractionChart($scope.data.dailyActivity, $scope);
    });
  }]).controller(id + ".Detail", ["$scope", "CardRegistry", 'CardUtils', '$routeParams', id + ".Utils", "$http", "Api", "activity.Utils", "User", "currentUserPerson", function ($scope, CardRegistry, CardUtils, $routeParams, Utils, $http, Api, ActivityUtils, User, currentUserPerson) {
    $scope.cardId = $routeParams.cardId;
    $scope.personId = $routeParams.personId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;

    // Not shown in preview/directlink
    if ($scope.config && $scope.config.filter) {
      $scope.subDetails = [{
        text: "Download interaction statements",
        downloadData: true,
        tooltip: "Download interaction statements",
        callback: ActivityUtils.prepareCsvExport($scope.config.filter).csvDownloadUrl
      }];
    }
    if ($scope.cardId === 'preview' && (!$scope.config.filter.personIds || $scope.config.filter.personIds.length === 0) && (!$scope.config.filter.personCustomIds || $scope.config.filter.personCustomIds.length === 0)) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please select a person";
      return;
    }
    if ($scope.cardId && $scope.cardId !== 'preview') {
      $scope.config = $scope.card.configuration;
    } else {
      // If the cardId is set to preview already, we're in explorer
      if ($scope.cardId === 'preview') {
        // We need to set the personId from the config
        var previewCard = CardRegistry.get($scope.cardId);
        $scope.personId = previewCard.configuration.filter.personCustomIds ? previewCard.configuration.filter.personCustomIds[0] : previewCard.configuration.filter.personIds[0];
      } else {
        // Otherwise, it's a direct link with a person id that's already set
        // we need to fake preview mode and the card template
        $scope.cardId = "preview";
        $scope.card.template = {
          name: 'person',
          cartridge: {
            name: 'builtin'
          }
        };
        $scope.card.configuration = {
          "filter": {
            "personIds": [$scope.personId]
          }
        };
      }
      $scope.isPreview = true;
    }
    Utils.fetchPersonData($scope.cardId, $scope).then(function success(response) {
      $scope.data = response.results[0].result;
      $scope.card.title = $scope.data.person.name;
      $scope.hasData = true;

      // Setup pagenote with our response info
      $scope.reportMetadata = _.extend({}, response);
      $scope.reportMetadata.totalHits = response.totalHits;
      _.defer(function () {
        $scope.pagenote.setReportMetadata($scope.reportMetadata);
      }, 0);
      Utils.setupInteractionChart($scope.data.dailyActivity, $scope);

      // Construct group display text
      var groupCnt = $scope.data.groups.length;
      if (groupCnt > 0) {
        if (groupCnt === 1) {
          $scope.groupDisplayText = "Group: " + $scope.data.groups[0];
        } else {
          $scope.groupDisplayText = "Groups: " + $scope.data.groups[0];
          for (var i = 1; i < groupCnt; i++) {
            // if there's none left
            if (i === groupCnt) {
              $scope.groupDisplayText += $scope.data.groups[i];
            }
            // if there's one left
            else if (i === groupCnt - 1) {
              $scope.groupDisplayText += " and " + $scope.data.groups[i];
            } else {
              $scope.groupDisplayText += ", " + $scope.data.groups[i];
            }
          }
        }
      }
    });
    var programDataUrl;
    if ($scope.cardId !== "preview") {
      programDataUrl = Api.url('/personcard/programs?cardId=' + $scope.cardId);
    } else {
      // Direct link -- no card
      programDataUrl = Api.url('/personcard/programs/person/customId/' + $scope.personId);
    }
    $scope.expandRow = function (row) {
      row.expand = !row.expand;
    };

    // check if row is "expanded" and return appropriate css class name
    $scope.getRowState = function getRowState(row) {
      return row.expand ? 'expand-open' : 'expand-closed';
    };

    // Fetch this person's program then fetch each program's report
    $http.get(programDataUrl).then(function (programsResponse) {
      var _programsResponse$dat = programsResponse.data,
        programs = _programsResponse$dat.programs,
        person = _programsResponse$dat.person;
      if (person.id === DYNAMIC_PERSON_ID) {
        person = currentUserPerson;
      }
      $scope.programs = programs;
      $scope.person = person;
      CardUtils.setNavElements($scope, person.name);

      // Get program details so we can show percent complete
      _.each($scope.programs, function (program) {
        $scope.program = program;
        Utils.fetchPersonData($scope.cardId, $scope).then(function assign(data) {
          program.progress = data.results[0].result.program.progress;
        });
      });
    });
  }]).controller(id + '.UniqueActivitiesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for an activity";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Activity",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "statementCount",
        "Descending": "-statementCount"
      }
    }, {
      "title": "Last interaction",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];

    // What does fetchData return?  It returns a promise
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.uniqueActivities;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PersonLearningPathsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a learning path";
    $scope.inputSize = "23";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Learning Path",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Started",
      "options": {
        "Ascending": "firstAccess",
        "Descending": "-firstAccess"
      }
    }, {
      "title": "Progress",
      "options": {
        "Ascending": "progress",
        "Descending": "-progress"
      }
    }, {
      "title": "Status",
      "options": {
        "Ascending": "progress",
        "Descending": "-progress"
      }
    }, {
      "title": "Last access",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.learningPaths;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PersonAssessmentsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for an assessment";
    $scope.inputSize = "22";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Assessment",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Completions",
      "options": {
        "Ascending": "completions",
        "Descending": "-completions"
      }
    }, {
      "title": "Successes",
      "options": {
        "Ascending": "successes",
        "Descending": "-successes"
      }
    }, {
      "title": "Last score",
      "options": {
        "Ascending": "score",
        "Descending": "-score"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.assessments;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PersonCompetenciesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a competency";
    $scope.inputSize = "22";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Competency",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Proficiency",
      "options": {
        "Ascending": "score",
        "Descending": "-score"
      }
    }, {
      "title": "Times practiced",
      "options": {
        "Ascending": "matchCount",
        "Descending": "-matchCount"
      }
    }, {
      "title": "Last practiced",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.competencies;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PersonContributingSystemsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a system";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Contributing System",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Unique activities",
      "options": {
        "Ascending": "uniqueActivityCount",
        "Descending": "-uniqueActivityCount"
      }
    }, {
      "title": "Total activities",
      "options": {
        "Ascending": "statementCount",
        "Descending": "-statementCount"
      }
    }, {
      "title": "Last access",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.dataOrigins;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + ".CardConfiguration", ["$scope", "ExplorerService", function ($scope, ExplorerService) {
    $scope.cardToEdit = ExplorerService.getCard() || {};
    $scope.validation = $scope.validation || {};
    $scope.hide.activity = true;
    $scope.hide.dates = true;
    $scope.hide.advancedConfiguration = true;
    $scope.peoplePickerConfig.personPicker.singlePerson = true;
    $scope.peoplePickerConfig.excludedPeopleOrGroups = [];

    // When we use a custom config section, you have to watch at least one property in order to get
    // the preview 'refresh' to happen when you switch to the template/card type.
    $scope.$watch("workingConfig.filter.personCustomIds", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.$watch("peoplePickerConfig.selectedPeopleOrGroups", function () {
      // If we only want a single person, use the second person (one that was just added)
      if ($scope.peoplePickerConfig.personPicker.singlePerson && $scope.peoplePickerConfig.selectedPeopleOrGroups.length > 0) {
        $scope.cardText.title = $scope.peoplePickerConfig.selectedPeopleOrGroups[0].name;
        $scope.cardToEdit.title = $scope.peoplePickerConfig.selectedPeopleOrGroups[0].name;
      }
    }, true);

    // Clear out these non-configurable properties
    $scope.activityPickerConfig.clearActivities();
    $scope.datePickerConfig.clearCustomDate("from");
    $scope.datePickerConfig.clearCustomDate("to");

    //If upon entry we have more than one personId selected clear out the selections
    if ($scope.peoplePickerConfig.selectedPeopleOrGroups.length > 1) {
      var isFirst = true;
      _.each($scope.peoplePickerConfig.selectedPeopleOrGroups, function (entity) {
        var isAGroup = !entity.hasOwnProperty("personas");
        if (isAGroup || !isFirst) {
          entity.selected = false;
          $scope.peoplePickerConfig.removePersonOrGroup(entity);
        } else if (isFirst) {
          // Keep the first person
          isFirst = false;
        }
      });
    }
  }]);
})();
